/** Nami AbilitySpec seed kit (wiki-aligned numeric batch 1). */
export const NAMI_ABILITY_DEFS = [
  {
    id: 'nami_q',
    champKey: 'nami',
    slot: 'Q',
    name: 'Aqua Prison',
    targeting: 'ground_aoe',
    range: 850,
    castTime: 0.25,
    effectDelay: 0.726,
    travelSpeed: null,
    width: null,
    radius: 200,
    cooldown: 12,
    manaCost: 60,
    vfxId: 'nami_q',
    cc: { type: 'stun', duration: 1.5 },
    status: 'wired'
  },
  {
    id: 'nami_w',
    champKey: 'nami',
    slot: 'W',
    name: 'Ebb and Flow',
    targeting: 'targeted',
    range: 725,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: 800,
    cooldown: 10,
    manaCost: 70,
    vfxId: 'nami_w',
    status: 'wired'
  },
  {
    id: 'nami_e',
    champKey: 'nami',
    slot: 'E',
    name: "Tidecaller's Blessing",
    targeting: 'targeted',
    range: 800,
    castTime: 0.25,
    travelSpeed: null,
    width: null,
    radius: null,
    duration: 6,
    cooldown: 11,
    manaCost: 55,
    vfxId: 'nami_e',
    affects: 'allies',
    status: 'wired'
  },
  {
    id: 'nami_r',
    champKey: 'nami',
    slot: 'R',
    name: 'Tidal Wave',
    targeting: 'skillshot_line',
    range: 2750,
    castTime: 0.5,
    travelSpeed: 850,
    width: 500,
    radius: 250,
    cooldown: 120,
    manaCost: 100,
    vfxId: 'nami_r',
    cc: { type: 'knockup', duration: 0.5 },
    status: 'wired'
  }
];
